import React from 'react';
import { MOCK_UP_BACKGROUND_LAYER } from '../../../../propTypes';
import {
    DEFAULT_Z_INDEX,
    DEFAULT_MIX_BLEND_MODE,
    DEFAULT_OPACITY,
    GRADIENT_TYPES
} from '../../constants';
import { MockUpLayer } from '../MockUpLayer';
import './index.scss';
import getGradientBackgroundColor from './lib/getGradientBackgroundColor';

export const MockUpGradientLayer = ({
    background,
    zIndex = DEFAULT_Z_INDEX,
    gradientType = GRADIENT_TYPES.RADIAL,
    mixBlendMode = DEFAULT_MIX_BLEND_MODE,
    opacity = DEFAULT_OPACITY,
    transformOrigin,
    transform
}) => {
    const backgroundColor = getGradientBackgroundColor(background, gradientType);

    return (
        <MockUpLayer mixBlendMode={mixBlendMode}
            background={backgroundColor}
            opacity={opacity}
            zIndex={zIndex}
            transformOrigin={transformOrigin}
            transform={transform}/>
    );
};

MockUpGradientLayer.propTypes = MOCK_UP_BACKGROUND_LAYER;
